<template>
  <tab-layout :actionBar="true">
    <div v-if="loadError" role="alert" class="alert alert-warning" slot="tabContent">{{ loadError }}</div>
    <div v-else-if="draftId && !details" class="text-center py-5" slot="tabContent">
      <div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>
    </div>
    <draft-add-details v-else :details="details" :edit="!!draftId" slot="tabContent" class="row mx-0 show active" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
import axios from 'axios'
import tabLayout from '@/components/TabLayout'
import draftAddDetails from './DraftAddDetails'

export default {
  name: 'DraftCreate',
  props: ['draftId'],
  components: {
    'tab-layout': tabLayout,
    'draft-add-details': draftAddDetails
  },
  data() {
    return {
      details: null,
      loadError: ''
    }
  },
  watch: {
    draftId: 'loadDraft'
  },
  created() {
    this.loadDraft()
  },
  methods: {
    loadDraft() {
      this.details = null
      this.loadError = ''
      if (!this.draftId) return
      axios.get(`${this.$api}/admin/draft-details/${this.draftId}`).then((response) => {
        if (response.data.status === 'success') {
          this.details = response.data.data
        } else {
          this.loadError = 'Draft not found.'
        }
      }).catch(() => {
        this.loadError = 'Unable to receive data from the server. Please reload the page.'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Drafts/Add/DraftAdd.vue